import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/relatorios/controle-saldos/ControleSaldosApiClient'
import DownloadFile from '@/core/utils/DownloadFile'

export default {
	async [actionTypes.RELATORIOS.CONTROLE_SALDOS.BAIXAR_RELATORIO](context, idDocumento) {
		const response = await api.baixarRelatorioControleSaldo(idDocumento)
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
}
